export default "__VITE_PUBLIC_ASSET__3bedbd9e__"